import { render } from "./ProgrammeCard.vue?vue&type=template&id=311601e1"
import script from "./ProgrammeCard.vue?vue&type=script&lang=js"
export * from "./ProgrammeCard.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__